import { ProjectFilterValues, ProjectsResponse } from "@dune/types";
import { projectFilter, RoleEnum } from "@dune/vars";
import React, { useState } from "react";
import { useMe } from "../../../api/queries/users.queries";
import { ProjectTabs } from "./ProjectTabs";
import { ProjectsList } from "./ProjectsList";

interface ProjectsSectionProps {
	projectsData?: ProjectsResponse;
	isLoading: boolean;
	error: Error | null;
}

export const ProjectsSection: React.FC<ProjectsSectionProps> = ({
	projectsData,
	isLoading,
	error,
}) => {
	const { me: user } = useMe();
	const [activeFilter, setActiveFilter] = useState<ProjectFilterValues>(
		projectFilter.TOUS,
	);

	return (
		<div className="h-full flex flex-col overflow-hidden bg-gray-50 rounded-lg border border-gray-100 p-3">
			{user?.role !== RoleEnum.SYNDIC && (
				<div className="flex-shrink-0 mb-4">
					<ProjectTabs
						activeFilter={activeFilter}
						onFilterChange={setActiveFilter}
						projectsData={projectsData}
						isLoading={isLoading}
					/>
				</div>
			)}
			<div className="flex-1 overflow-hidden">
				<ProjectsList
					activeFilter={activeFilter}
					projectsData={projectsData}
					isLoading={isLoading}
					error={error}
				/>
			</div>
		</div>
	);
};
